import { useEffect, useState, useRef } from "react";
// import horizonImage from "../assets";
// import horizonHoverImage from "../assets";
// import tranquilImage from "../assets/images/Tranquil Prod Image 1.png";
// import tranquilHoverImage from "../assets/images/Tranquil 2.png";
// import valeImage from "../assets/images/Vale Prod Image 1.png";
// import valeHoverImage from "../assets/images/Vale 2.png";
// import lagoonImage from "../assets/images/Lagoon Prod Image 1.png";
// import lagoonHoverImage from "../assets/images/Lagoon 2.png";

const fragrances = [
  {
    id: 1,
    name: "Horizon",
    profile: "Fresh · Citrus · Airy",
    description: "Bright and uplifting, perfect for morning-facing spaces and wellness environments.",
    image: '/images/Horizon Prod Image 1.png',
    hoverImage: '/images/Horizon 2.png'
  },
  {
    id: 2,
    name: "Tranquil",
    profile: "Soft · Botanical · Serene",
    description: "Delicate florals balanced with green notes, ideal for boutique hotels and fine dining.",
    image: '/images/Tranquil Prod Image 1.png',
    hoverImage: '/images/Tranquil 2.png'
  },
  {
    id: 3,
    name: "Vale",
    profile: "Deep · Woody · Mysterious",
    description: "Rich and contemplative, suited for evening venues, lounges, and intimate spaces.",
    image: '/images/Vale Prod Image 1.png',
    hoverImage: '/images/Vale 2.png'
  },
  {
    id: 4,
    name: "Lagoon",
    profile: "Deep · Woody · Mysterious",
    description: "Clean, oceanic freshness infused with gentle aromatics, crafted for refreshing ambience",
    image: '/images/Lagoon Prod Image 1.png',
    hoverImage: '/images/Lagoon 2.png'
  }
];

const CollectionSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="collection" className="collection-section" ref={sectionRef} data-testid="collection-section">
      <div className={`collection-header ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
        <span className="collection-label">Our Fragrance Profiles</span>
        <h2 className="collection-title">Four Fragrances, Infinite Possibilities</h2>
        <p className="collection-description">
          Each profile serves as a starting point for your bespoke scent journey. 
          We customize and refine to match your brand's unique essence.
        </p>
      </div>

      <div className="collection-grid">
        {fragrances.map((fragrance, index) => (
          <div
            key={fragrance.id}
            className={`product-card ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
            style={{ animationDelay: `${(index + 1) * 200}ms` }}
            data-testid={`fragrance-card-${fragrance.id}`}>
            <div className="product-image-wrapper">
              <img
                src={fragrance.image}
                alt={`${fragrance.name} fragrance profile`}
                className="product-image product-image-default"
              />
              {fragrance.hoverImage && (
                <img
                  src={fragrance.hoverImage}
                  alt=""
                  aria-hidden="true"
                  className="product-image product-image-hover"
                />
              )}
              <div className="product-overlay"></div>
            </div>
            <div className="product-info">
              <h3 className="product-name">{fragrance.name}</h3>
              <p className="product-subtitle">{fragrance.profile}</p>
              <p className="product-description">{fragrance.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CollectionSection;
